import styled from "styled-components";
import { UiConstants } from "../../data/UiConstants";
export const MenuCardScrollContainer = styled.div.withConfig({
  displayName: "MenuCardScrollContainer",
  componentId: "sc-1vwhimw-0"
})(["max-height:300px;overflow:auto;border-radius:", ";border:solid 1px #888888;"], UiConstants.BORDER_RADIUS);